import { AccessCodes } from '@pm2/api';
import { urlPatterns } from '@pm2/sitemap-utils';
import { Link } from '@provider/navigation';
import { configRefs } from '@utils/constants';
import { jsx } from 'react/jsx-runtime';

function ResourceLink({
  resource,
  children,
  ...props
}) {
  if (!resource.src || resource.accessCode !== AccessCodes.ALLOWED) {
    return null;
  }
  switch (resource.kind) {
    case "Document":
      return /*#__PURE__*/jsx(Link, {
        href: `${configRefs.apis.pm2.media.dangerouslyAssertSyncValue()}${resource.src}`,
        target: "_blank",
        download: true,
        ...props,
        children: children
      });
    case "ExternalLink":
      return /*#__PURE__*/jsx(Link, {
        href: resource.src,
        target: "_blank",
        ...props,
        children: children
      });
    case "InternalLink":
      return /*#__PURE__*/jsx(Link, {
        href: resource.src,
        ...props,
        children: children
      });
    case "ContentElement":
      switch (resource.target) {
        case "Page":
          return /*#__PURE__*/jsx(Link, {
            href: urlPatterns.resource(resource.id),
            ...props,
            children: children
          });
        case "NewWindow":
          return /*#__PURE__*/jsx(Link, {
            href: urlPatterns.resource(resource.id),
            target: "_blank",
            ...props,
            children: children
          });
        default:
          return /*#__PURE__*/jsx(Link, {
            href: urlPatterns.element(resource.src),
            target: "_lightbox",
            ...props,
            children: children
          });
      }
    case "Page":
      switch (resource.target) {
        case "Page":
          return /*#__PURE__*/jsx(Link, {
            href: urlPatterns.resource(resource.id),
            ...props,
            children: children
          });
        case "NewWindow":
          return /*#__PURE__*/jsx(Link, {
            href: urlPatterns.resource(resource.id),
            target: "_blank",
            ...props,
            children: children
          });
        default:
          return /*#__PURE__*/jsx(Link, {
            href: urlPatterns.page(resource.src),
            target: "_lightbox",
            ...props,
            children: children
          });
      }
    case "PredefinedNote":
      {
        const predefinedNoteId = resource.src;
        const handleClick = () => {
          if (typeof gNotebook === "undefined") {
            alert("Der opstod en fejl da vi forsøgte at åbne ressourcen, prøv igen.");
            return;
          }
          gNotebook.addNoteFromPredefined({
            predefinedNoteId
          }).then(noteId => {
            gNotebook?.requestOpen({
              noteId
            });
          }).catch(() => {
            alert("Der opstod en fejl da vi forsøgte at åbne ressourcen, prøv igen.");
          });
        };
        return /*#__PURE__*/jsx("button", {
          ...props,
          onClick: handleClick,
          children: children
        });
      }
  }
  return null;
}

export { ResourceLink };
//# sourceMappingURL=atom.resource-link.js.map
